import { useTranslations } from 'next-intl';

interface SurveyFormTextFieldProps {
	register: any;
	error: any;
}

export const SurveyFormTextField = ({ register, error }:SurveyFormTextFieldProps) => {
	const t = useTranslations('General');

	return (
		<div className="survey-form__content" data-error={!!error}>
			<div className="survey-form__textfield" data-error="false">
				<textarea 
					{...register('comment')}
					className="survey-form__textarea" 
					placeholder={t('lbl_GSabaSurveyAnswer')}
				>
				</textarea>
				<div className="survey-form__error-msg">
					{error?.message && 
					<>
						<span className="survey-form__icon-error"></span>
						<span>{t(error.message)}</span>
					</>}
				</div>
				<div className="survey-form__textarea-text">
					{t('lbl_GSabaSurveyCharactersMore02')}
				</div>
			</div>
		</div>
	)
}